import React from 'react';
import PropTypes from 'prop-types';
import { Modal, P } from '@decisiv/ui-components';
import Trash from '@decisiv/iconix/lib/components/Trash';
import { t, Trans } from '@lingui/macro';
import WrapperWithLoading from '../../components/WrapperWithLoading';

const CacheModal = ({ visible, loading = false, onClear, onClose }) => (
  <Modal
    actions={[
      {
        text: t`Clear Cache`,
        onClick: onClear,
        intent: 'danger',
      },
      { text: t`Cancel`, onClick: onClose },
    ]}
    icon={Trash}
    color="danger"
    onClose={onClose}
    title={t`Clear Cache`}
    visible={visible}
  >
    {loading ? (
      <WrapperWithLoading
        loading={loading}
        description={t`Clearing Cache, it is okay to close this tab`}
      />
    ) : (
      <>
        <P color="alaskanHusky" weight="medium" marginTop={1}>
          <Trans>
            This cannot be undone. Clearing the cache permanently deletes all
            stored responses, and every request that would’ve been served from
            cache will call the target system directly instead.
          </Trans>
        </P>
        <P color="alaskanHusky" weight="medium" marginTop={1}>
          <Trans>
            For a large cache, that sudden shift in traffic can spike call
            volume enough to overwhelm the target system.
          </Trans>
        </P>
      </>
    )}
  </Modal>
);

CacheModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onClear: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default CacheModal;
